module.exports = __webpack_public_path__ + "img/gmail.3ffbee6b.png";